"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var font = {
  primaryRegular: 'inter, "Helvetica Neue", Arial, sans-serif',
  secondaryLight: '"montserratlight", Helvetica, Arial',
  secondaryRegular: '"montserratregular", Helvetica, Arial',
  secondaryMedium: 'montserratmedium, Arial, sans-serif',
  secondarySemiBold: 'montserratsemibold, Arial, sans-serif',
  secondaryBold: '"montserratbold", Helvetica, Arial'
};
var _default = exports.default = font;